"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceBodyParser = void 0;
const body_parsing_error_1 = require("../errors/body-parsing.error");
class PreferenceBodyParser {
    constructor(config) {
        this.config = config;
        if (config.loggerService) {
            this.log = config.loggerService.getLogger('dp-user-preferences-sdk');
        }
        else {
            this.log = console;
        }
    }
    toArray(preferenceObject) {
        try {
            let preferenceValueArray = [];
            for (const [key, value] of Object.entries(preferenceObject)) {
                preferenceValueArray.push({
                    key: key,
                    value: value,
                });
            }
            return preferenceValueArray;
        }
        catch (error) {
            this.log.error('Cannot parse the object');
            throw new body_parsing_error_1.BodyParsingError('Cannot parse the object');
        }
    }
    toObject(preferenceArray) {
        try {
            const preferenceObject = preferenceArray.reduce(function (preferenceValueObject, currentObject) {
                preferenceValueObject[currentObject.key] = currentObject.value;
                return preferenceValueObject;
            }, {});
            return preferenceObject;
        }
        catch (error) {
            this.log.error('Cannot parse the array');
            throw new body_parsing_error_1.BodyParsingError('Cannot parse the array');
        }
    }
    toObjectFromList(preferenceArray) {
        try {
            let toObject = this.toObject;
            const preferenceObject = preferenceArray.reduce(function (preferenceValueObject, currentObject) {
                if (currentObject.value instanceof Array) {
                    preferenceValueObject[currentObject.key] = toObject(currentObject.value);
                }
                else {
                    preferenceValueObject[currentObject.key] = currentObject.value;
                }
                return preferenceValueObject;
            }, {});
            return preferenceObject;
        }
        catch (error) {
            this.log.error('Cannot parse the array');
            throw new body_parsing_error_1.BodyParsingError('Cannot parse the array');
        }
    }
}
exports.PreferenceBodyParser = PreferenceBodyParser;
//# sourceMappingURL=preference-body.parser.js.map